<template>
  <el-form
    ref="ruleForm"
    :model="item"
    label-position="left"
    label-width="160px"
  >
    <form-item-group
      title="Cards"
      :min="CONSTANT.CREATIVE_DEFAULT_VALUE.CARDS.MIN_NUM"
      :max="CONSTANT.CREATIVE_DEFAULT_VALUE.CARDS.MAX_NUM"
      :group-item="CONSTANT.CREATIVE_DEFAULT_VALUE.CARDS.ITEM"
      v-model="item.cards"
    >
      <template slot-scope="{ index }">
        <el-form-item
          label="Image"
          :prop="`cards.${index}.image_url`"
          :rules="[
            ...imageSizeRule(limited_size.image),
            ...urlRule('image_url'),
          ]"
          label-width="120px"
        >
          <file-input
            accept="image/jpeg, image/png, image/gif"
            v-model="item.cards[index].image_url"
            :check_upload_image_size="{
              ...limited_size.image,
              enable: true,
            }"
          ></file-input>
        </el-form-item>
        <el-form-item
          label="Landing Page"
          :prop="`cards.${index}.landing_page`"
          :rules="urlRule('landing_page')"
          label-width="120px"
        >
          <el-input v-model="item.cards[index].landing_page"></el-input>
        </el-form-item>
      </template>
    </form-item-group>
    <el-form-item label="Bottom Offset" label-width="137px">
      <Offset v-model="item.offset_bottom"> </Offset>
    </el-form-item>
  </el-form>
</template>

<script>
import MixFormRule from "@/components/mixins/formRule";
import MixCreativeForm from "@/components/mixins/creativeForm";
const { CARDS } = CONSTANT.CREATIVE_DEFAULT_VALUE;
export default {
  data() {
    return {
      item: {
        cards: [...Array(CARDS.MIN_NUM)].map(() => _.cloneDeep(CARDS.ITEM)),
        offset_bottom: {
          number: "",
          unit: "px",
        },
      },
      limited_size: {
        image: {
          width: {
            max: 640,
            min: 640,
          },
          height: {
            max: 360,
            min: 360,
          },
        },
      },
    };
  },
  mixins: [MixFormRule, MixCreativeForm],
  methods: {
    setData(row) {
      this.item.cards = _.map(row.cards, (card) => {
        return {
          image_url: decodeURI(card.image_url),
          landing_page: decodeURI(card.landing_page),
        };
      });
      this.item.offset_bottom.unit = row.offset_bottom_unit;
      this.item.offset_bottom.number = row.offset_bottom_number;
    },
    async getData(setObj) {
      setObj.cards = _.map(this.item.cards, (card) => {
        return {
          image_url: card.image_url.replace(/[^\x00-\x7F]/g, (c) => encodeURI(c)),
          landing_page: card.landing_page.replace(/[^\x00-\x7F]/g, (c) => encodeURI(c)),
        };
      });
      setObj.offset_bottom_unit = this.item.offset_bottom.unit;
      setObj.offset_bottom_number = this.item.offset_bottom.number;
      return setObj;
    },
  },
};
</script>

<style></style>
